import Moment from 'moment';
/**
 * Formats a date.
 *
 * @param date
 * @param format
 */
export function formatDate(date, format = null) {
    if (format) {
        return Moment(date).format(format);
    }
    else if (Moment().format('D/M/Y') === Moment(date).format('D/M/Y')) {
        return 'Today at ' + Moment(date).format('HH:mm');
    }
    else if (Moment().format('Y') === Moment(date).format('Y')) {
        return Moment(date).format('D MMM [at] HH:mm');
    }
    return Moment(date).format('D/M/Y [at] HH:mm');
}
export default formatDate;
